import { TableUtils } from "../../../../../../../utils";
import {
  editableTableActionWidth,
  IAvisEditableListFieldArrayProps,
} from "../../../types";
import { AvisEditableListHeaderRow } from "./";

export function AvisEditableListHeader<T extends object, P extends object>(
  props: Readonly<IAvisEditableListFieldArrayProps<T, P>>,
) {
  const { fields, disabled } = props;

  return (
    <>
      <colgroup>
        {!disabled && (
          <col style={{ minWidth: `${editableTableActionWidth}px` }} />
        )}
        {fields.map((f) => (
          <col
            key={f.name.toString()}
            style={{
              minWidth: TableUtils.convertWidth(f.minWidth),
              maxWidth: TableUtils.convertWidth(f.maxWidth),
              width: TableUtils.convertWidth(f.width),
            }}
          />
        ))}
      </colgroup>
      <thead>
        <AvisEditableListHeaderRow {...props} />
      </thead>
    </>
  );
}
